import React from 'react'
import Style from './SupplierSliderItem.module.css'
import { useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart, faMapPin } from '@fortawesome/free-solid-svg-icons';
import { cal_dis, randomNumberInRange } from '../../Utils/Helper/Helper';
import { faHeart as fillHeart } from "@fortawesome/free-solid-svg-icons";
const SupplierSliderItem = ({item,addFavorite}) => {
  const userLat=localStorage.getItem('userLat')
  const userLon=localStorage.getItem('userLon')
  const history=useHistory()
  return (
    <div className={`${Style.SlideItemHolder} keen-slider__slide`}>
      {/* <div className={Style.favoriteHolder} onClick={()=>addFavorite(item)}>
        {parseInt(item.favorite) === 0 ? (
          <FontAwesomeIcon icon={faHeart} />
        ) : (
          <FontAwesomeIcon icon={fillHeart} color="red" />
        )}
      </div> */}
      <div className={Style.CoverHolder}>
          <img
            src={`//cdn.barest.ir/supplier/cover/${item.cover}.jpg`}
            alt={item.supplier}
            className={Style.hiddenUntilLoaded}
            onLoad={(e) => (e.currentTarget.dataset.loaded = "true")}
            onError={(e) => (e.currentTarget.dataset.loaded = "true")}
          />
          <div className={Style.skeleton + " " + Style.coverSkeleton} aria-hidden="true"></div>
      </div>
      <div className={Style.logoHolder}>
          <img
            src={`//cdn.barest.ir/supplier/logo/${item.logo}.jpg`}
            alt=""
            className={Style.hiddenUntilLoaded}
            onLoad={(e) => (e.currentTarget.dataset.loaded = "true")}
            onError={(e) => (e.currentTarget.dataset.loaded = "true")}
          />
          <div className={Style.skeleton + " " + Style.logoSkeleton} aria-hidden="true"></div>
      </div>
      <div className={Style.SupplierInfoHolder}>
        <h5 onClick={()=>history.push(`/supplier/${item.id}/`)}>{item.supplier}</h5>
        <p><FontAwesomeIcon icon={faMapPin} color='#c90054'/> {cal_dis([item.lat,item.lon],[userLat,userLon])}ی شما</p>
      </div>
    </div>
  )
}

export default SupplierSliderItem